<script lang="ts" setup="">
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

import { TextPromptModal, useToastStore } from '@nora-monorepo/ui-shared';

import { useOperationChatModalStore } from '#nora-ui/components/modals/operation-chat-modal/operation-chat-modal-store';

const { t } = useI18n();
const toastStore = useToastStore();
const operationChatModalStore = useOperationChatModalStore();
const { showOperationChatModal, operationTitle } = storeToRefs(operationChatModalStore);

async function saveConversation(conversationTitle: string) {
  try {
    await operationChatModalStore.saveOperationConversation(conversationTitle);
  }
  catch {
    toastStore.addError({
      message: t('errors.createConversationError'),
    });
  }
}

function onClose() {
  operationChatModalStore.closeModal();
}
</script>

<template>
  <TextPromptModal
    :model-value="showOperationChatModal"
    title="Conversation"
    :initial-text="`${operationTitle} - `"
    :text-field-label="t('conversationDialog.titleLabel')"
    :placeholder="t('conversationDialog.titlePlaceholder')"
    :ok-label="t('common.save')"
    :cancel-label="t('common.cancel')"
    @save="saveConversation"
    @cancel="onClose"
  />
</template>
